export function measures(state) {
  return state.measures
}

export function landApplications(state) {
  return state.landApplications
}

export function shaftApplications(state) {
  return state.shaftApplications
}
